import { Box, Typography } from "@mui/material";
import { useStyles } from "./Header.styles";
import { StatusLight, RangeDropdown } from "./components";
import { useTranslation } from "react-i18next";

export const Header = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={classes.header}>
            <Box className={classes.statusBox}>
                <Typography variant="subtitle2" className={classes.label}>
                    {t("locations.mill_network_details.status").toUpperCase()}
                </Typography>
                <StatusLight />
            </Box>
            <Box className={classes.dropdownBox}>
                <RangeDropdown />
            </Box>
        </div>
    );
};
